/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFollowUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.707 5h-1v3h2V7h12v3.586l-1.293-1.293L15 10.707l3 3 .707.707.707-.707 3-3L21 9.293l-1.293 1.293V5h-1zm14 14h1v-3h-2v1h-12v-3.586L7 14.707l1.414-1.414-3-3-.707-.707-.707.707-3 3 1.414 1.414 1.293-1.293V19h1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFollowUp as FollowUp };
